import {ApiResponse} from "../models/ApiResponse";
import MainBackendAxios from "../utils/MainBackendAxios";
import {FunctionsHelper} from "../utils/FunctionsHelper";
import {ApplicationProfileType} from "../models/ApplicationProfileType";

export const ApplicationProfileTypeService = {
    getAll: async (): Promise<ApiResponse<ApplicationProfileType[]>> => {
        try {
            const response = await MainBackendAxios.get(`/application-profile-type/get-all`);

            return {
                success: true,
                status: response.status,
                data: response?.data?.data,
            };
        } catch (err: any) {
            return FunctionsHelper.getErrorFormat(err);
        }
    },
};
